<template>
<div>
  <div class="app-page" v-if="this.$route.path!='/printTransportTicket'">
    <top />
    <div class="holder1"></div>
    <router-view></router-view>
    <!-- <div class="holder"></div> -->
    <bottom class="footer" />
    <!-- <onlineService /> -->
  </div>
  <div v-else>
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import top from "@/components/index/top";
import bottom from "@/components/index/bottom";
// import onlineService from "@/components/index/onlineService";
export default {
  components: {
    top,
    bottom,
    // onlineService
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
body{
  background-color: #f8f8f8;
}
.app-page {
  background-color: #f8f8f8;
  width: 100%;
  min-height: 100vh;
  padding-bottom: 200px;
  position: relative;
}
.holder1 {
  height: 40px;
  width: 100%;
}
.holder {
  height:100px;
  width: 100%;
}

/* 解决tab添加border后表头错位 */
/deep/ .el-table .gutter {
  display: table-cell !important;
}

.footer{
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 90;
}
.spinner-icon {
  border-top-color: rgb(34, 221, 43) !important;
  border-left-color: rgb(34, 221, 43) !important;
}
</style>
